import theme from "@/styles/themes/theme";
import { css } from "@emotion/react";

export const styles = {
  video: css`
    height: 101%;
    width: 322px;
    object-fit: cover;

    ${theme.breakpoints.down("md")} {
      width: 100%;
    }
  `,
  media_container: css`
    align-self: center;
    overflow: hidden;
    position: relative;
    justify-content: center;
    align-items: center;
    display: flex;

    position: absolute;
    right: 0;
    height: 100%;
    top: 0px;

    ${theme.breakpoints.down("md")} {
      right: 0;
      height: 190px;
      width: 100%;
      bottom: 0px;
      top: inherit;
    }
  `,
  image: css`
    object-fit: cover;
    height: 100%;
    width: 322px;

    ${theme.breakpoints.down("md")} {
      width: 100%;
    }
  `,
  play: css`
    position: absolute;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
  `,
  expand_image: css`
    position: absolute;
    justify-content: center;
    align-items: center;
    display: flex;
    bottom: 8px;
    left: 8px;
  `,
  playbuttom_image: css`
    width: 115px;
    height: 115px;

    ${theme.breakpoints.down("sm")} {
      width: 74px;
      height: 74px;
    }
  `
};
